<template>
    <div>
        <v-row>
            <v-col cols="5">
                <div class="font-weight-medium">
                From Values
                </div>
            </v-col>
            <v-col cols="7">
                <div class="font-weight-medium">
                To Values
                </div>
            </v-col>
        </v-row>
        <v-row v-for="(valueLookUp, index) in items" :key="index">
            <v-col cols="5">
                <v-text-field
                    v-model="valueLookUp.from_value"
                    label="From Value"
                    outlined
                    dense
                    hide-details
                    class="my-2"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-combobox
                    v-model="valueLookUp.to_value"
                    :label="toLabel"
                    :items="toValueOptions"
                    :return-object="false"
                    outlined
                    dense
                    hide-details
                    clearable
                    class="my-2"
                ></v-combobox>
            </v-col>
            <v-col cols="1">
                <v-btn icon class="delete-btn" :key="`delete-${index}`" v-if="items.length > 1" @click="removeValueLookUp(index)">
                    <v-icon>fa fa-times-circle</v-icon>
                </v-btn>

                <v-btn icon class="add-btn" :key="`add-${index}`" v-if="index === items.length - 1" @click="addValueLookUp">
                    <v-icon>fa fa-plus-circle</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped>
    .delete-btn:hover {
        color: red; /* Changes the icon color to red on hover */
    }
</style>

<script>
export default {
    props: {
        integration_id: { type: Number, required: true },
        toValueOptions: { type: Array, default: () => [] },
        toLabel: { type: String, default: 'Select To Value' },
        items: {type: Array, default: () => [] },
    },

    created() {
        if(this.items.length == 0) {
            // Initialize with one empty value lookup
            this.items.push({ integration_id: this.integration_id, from_value: '', to_value: '' });
        }
    },

    watch: {
        items: {
            handler(newValue) {
                this.$emit('update:items', newValue);
            },
            deep: true
        }
    },

    methods: {
        addValueLookUp() {
            this.items.push({ integration_id: this.integration_id, from_value: '', to_value: '' });
        },

        removeValueLookUp(index) {
            this.items.splice(index, 1);
        },
    },
};
</script>